const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Conheça",
    to: "/conheca",
  },
  {
    text: "Notícias",
    to: "/noticias",
  },
  {
    text: "Eventos",
    to: "/eventos",
  },
  {
    text: "Trabalhe Conosco",
    to: "/trabalhe-conosco",
  },
  {
    text: "Fale Conosco",
    to: "/fale-conosco",
  },
];

export { server, menu };
